import { queryKeyFn } from '../../generated/sitContext';
export const getUserQueryKey = queryKeyFn({
    path: '/users',
    operationId: 'getApiUser',
    variables: {},
});
//# sourceMappingURL=query-key.js.map